'use strict';

const React = require('react'),
  SessionStore = require('stores/SessionStore'),
  {t} = require('services/i18nextWrapper'),
  BeerStyleStore = require('stores/BeerStyleStore'),
  IconStore = require('stores/IconStore'),
  ContentUtils = require('utils/ContentUtils'),
  AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
  AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
  AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
  {FERMENTER_TYPE_TASK, PACKAGING_TYPE_TASK, BREWING_TYPE_TASK, getIconsMapping} = require('constants/AppConstants'),
  NavigationUtils = require('utils/NavigationUtils'),
  FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
  FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
  FormGroupDropdownCustom = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdownCustom'),
  FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
  Authentication = require('services/Security').Authentication,
  Stamps = require('components/Commons/Stamps/Stamps'),
  Stamp = require('components/Commons/Stamps/Stamp/Stamp'),
  DashboardServiceCache = require('services/DashboardServiceCache'),
  {map, filter, includes} = require('lodash/collection'),
  get = require('lodash/object').get,
  {Navigation} = require('react-router'),
  ga = require('react-ga');

const MAX_BREW_CONFIGURATION = 12;
// initialize array of [1...12] numbers
const BREW_NUMBERS = Array.apply(null, {length: MAX_BREW_CONFIGURATION}).map(Number.call, Number).map(num => num + 1);

const iconsProvider = {
  // notice in the following declaration we are passing the context,
  // because inside of method we need to be the DSC context.
  [FERMENTER_TYPE_TASK]: DashboardServiceCache.getFermenterIcons.bind(DashboardServiceCache),
  [PACKAGING_TYPE_TASK]: DashboardServiceCache.getPackagingIcons.bind(DashboardServiceCache),
  [BREWING_TYPE_TASK]: DashboardServiceCache.getBrewhouseIcons.bind(DashboardServiceCache)
};

let BeerStyleConfigurationAdmin = React.createClass({displayName: "BeerStyleConfigurationAdmin",

  mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

  getInitialState() {
    return {
      currentBeerStyle: NavigationUtils.getPathParam('styleBeer'),
      currentBeerStyleName: NavigationUtils.getQueryParam('beerStyleName'),
      currentPackagingDays: NavigationUtils.getQueryParam('packagingDays'),
      currentFermenterDays: NavigationUtils.getQueryParam('fermenterDays'),
      currentBrewingDays: NavigationUtils.getQueryParam('brewingDays'),
      typeTank: NavigationUtils.getQueryParam('type')
    };
  },

  componentDidMount() {
    this.fetchBeerStyleTasks();
    ga.pageview('/style-beer-admin-configuration');
  },

  _backToBeerStyle() {
    this.transitionTo('/styleBeer');
  },

  _goTo(type) {
    this.transitionTo('/styleBeer/:styleBeer/tasks?' +
      'type=:type&' +
      'packagingDays=:packagingDays&' +
      'fermenterDays=:fermenterDays&' +
      'beerStyleName=:beerStyleName&',
      {
        styleBeer: NavigationUtils.getPathParam('styleBeer'),
        packagingDays: NavigationUtils.getQueryParam('packagingDays'),
        fermenterDays: NavigationUtils.getQueryParam('fermenterDays'),
        beerStyleName: NavigationUtils.getQueryParam('beerStyleName'),
        type
      });
    window.location.reload(true);
  },

  fetchBeerStyleTasks() {
    IconStore.fetchIcons(icons => {
      BeerStyleStore.fetchStyleBeersConfiguration(this.state.currentBeerStyle, (configurationTask) => {
        const beerStyleConfigurationFiltered = filter(configurationTask, beerStyle => beerStyle.typeTank === this.state.typeTank);
        const dirtyIcons = get(icons, 'icons', []);
        const cleanIcons = map(dirtyIcons, icon => icon.iconDetail);
        const beerStyleConfigurationHydrated = this._hydrateConfigurationWithIcons(beerStyleConfigurationFiltered, cleanIcons);
        this.setState({
          beerStyleConfigurationTasks: beerStyleConfigurationHydrated
        });
      });
    });
  },

  _hydrateConfigurationWithIcons(configurationTasks, icons) {
    return map(configurationTasks, task => DashboardServiceCache.hydrateWithIcon(task, 'typeTask', 'admin', icons));
  },

  _onRowSelection(item,
                  itemIndex,
                  lastRowScrollPosition,
                  headerActiveFilters) {
    this.setState(
      prevState => {
        return {
          selectedTask: item,
          isEditMode: !prevState.isEditMode,
          headerActiveFilters
        };
      },
      () => {
        // stay the position of the scroll after row select when
        // the offset is outside of initial viewport page.
        this.getDOMNode().querySelector(
          '.mui-body-table'
        ).scrollTop = lastRowScrollPosition;
      }
    );
  },

  _onEnterPress() {
    if (this.onEnterKeyDown) {
      this.onEnterKeyDown();
    }
  },

  _addEnterKeyDown(onEnterKeyDown) {
    this.onEnterKeyDown = onEnterKeyDown;
  },

  _onDeleteBeerStyle(id, onSuccess, onFailure) {
    BeerStyleStore.deleteStyleBeersConfiguration(id, onSuccess, onFailure);
  },

  _onChangeBeerStyle(beerStyleConf, onSuccess, onFailure) {
    BeerStyleStore.changeBeerStyleConfiguration(beerStyleConf, onSuccess, onFailure);
  },

  _onAddBeerStyle(beerStyleConf, onSuccess, onFailure) {
    BeerStyleStore.addBeerStyleConfiguration(beerStyleConf, onSuccess, onFailure);
  },

  _onCancel() {
    this.setState({
      selectedTask: null
    });
  },

  _isValidDayTask(items, currentDay, selectedDay) {
    if (selectedDay && existAnotherTaskWithSameDay(items, currentDay, +selectedDay)) {
      return t('beer_style_configuration_admin_inline_error_one_task_per_day');
    }
    return ''; // empty is valid
  },

  _getBreadcrumbLinks(currentBeerStyleName) {
    return [
      {
        displayName: t('beer_style_configuration_label_name'),
        link: 'styleBeer'
      },
      {
        displayName: `${currentBeerStyleName}`
      }
    ];
  },

  _getStampsIcons(stamp) {
    const iconClassName = `icon-task ${get(stamp, 'icon.iconClassName')}`;
    return (
      React.createElement(Stamps, null, 
        React.createElement(Stamp, {
          text: get(stamp, 'day'), 
          classNameIcon: iconClassName}
        )
      )
    );
  },

  _getNavigationItems(type) {
    if (type === 'fermenter') {
      return [
        this.getButtonNavigation(t('beer_style_configuration_set_brewing_icons'), 'brewing'),
        this.getButtonNavigation(t('beer_style_configuration_set_packaging_icons'), 'packaging')
      ];
    } else if (type === 'brewing') {
      return [
        this.getButtonNavigation(t('beer_style_configuration_set_fermenting_icons'), 'fermenter'),
        this.getButtonNavigation(t('beer_style_configuration_set_packaging_icons'), 'packaging')
      ];
    } else {
      return [
        this.getButtonNavigation(t('beer_style_configuration_set_brewing_icons'), 'brewing'),
        this.getButtonNavigation(t('beer_style_configuration_set_fermenting_icons'), 'fermenter')
      ];
    }
  },

  getButtonNavigation(label, urlType) {
    return {
      type: 'NEW',
      permission: 'EDIT',
      el: (
        React.createElement(FormGroupButton, {
          label: label, 
          icon: "subdirectory_arrow_right", 
          type: "icon", 
          onClick: this._goTo.bind(this, urlType)}
        )
      )
    };
  },

  render() {
    let contextHolder = this.getContextHolderInstance();
    const {selectedTask, typeTank, currentBeerStyle, beerStyleConfigurationTasks, currentBeerStyleName} = this.state;
    const messages = {
      changeSuccessMessage: t('beer_style_configuration_admin_change_message_success'),
      changeFailureMessage: t('beer_style_configuration_admin_change_message_failure'),
      deleteSuccessMessage: t('beer_style_configuration_admin_delete_message_success'),
      addSuccessMessage: t('beer_style_configuration_admin_add_message_success'),
      addFailureMessage: t('beer_style_configuration_admin_add_message_failure')
    };

    const tasks = iconsProvider[typeTank]();
    const isAdminBrewing = typeTank === 'brewing';
    const additionalButtons = [
      {
        type: 'CHANGE',
        permission: 'EDIT',
        el: React.createElement(FormGroupButton, {
          label: t('back'), 
          icon: "subdirectory_arrow_left", 
          type: "icon", 
          onClick: this._backToBeerStyle}
        )
      },
      {
        type: 'NEW',
        permission: 'EDIT',
        el: React.createElement(FormGroupButton, {
          label: t('back'), 
          icon: "subdirectory_arrow_left", 
          type: "icon", 
          onClick: this._backToBeerStyle}
        )
      },
      ...this._getNavigationItems(typeTank)
    ];

    const availablesDays = typeTank === BREWING_TYPE_TASK ? BREW_NUMBERS : getAvailablesDays(this.state);
    const label = typeTank === BREWING_TYPE_TASK ? t('beer_style_configuration_admin_brew_turn_order') : t('day');
    const selectedDay = selectedTask ? selectedTask.day : null;
    const tankTypeFormatted = t(ContentUtils.getTankTypeConfiguration(typeTank).sectionName.toLowerCase());

    if (selectedTask) {
      // adapter selected item, in order to do the same reader attribute
      selectedTask.displayName = selectedTask.typeTask;
    }

    const formFieldsEl = [
      React.createElement(FormGroupDropdown, {
        operationsHolder: contextHolder, 
        additionalValidation: this._isValidDayTask.bind(this, beerStyleConfigurationTasks, selectedDay), 
        items: availablesDays, 
        readerAttribute: "day", 
        name: label, 
        value: selectedTask}
      ),

      React.createElement(FormGroupDropdownCustom, {
        items: tasks, 
        operationsHolder: contextHolder, 
        idAttribute: "name", 
        readerAttribute: "displayName", 
        customReaderWriterAttribute: "name", 
        writerAttribute: "typeTask", 
        name: t('icon'), 
        isRequired: true, 
        isRelaxedText: true, 
        floatingLabelText: t('select_icon'), 
        value: get(selectedTask, 'icon')}
      ),

      React.createElement(FormGroupTextfield, {
        operationsHolder: contextHolder, 
        readerAttribute: "label", 
        isRequired: false, 
        isRelaxedText: true, 
        name: t('label'), 
        value: selectedTask, 
        label: t('label'), 
        onEnter: this._onEnterPress}
      ),

      React.createElement(FormGroupTextfield, {
        operationsHolder: contextHolder, 
        readerAttribute: "description", 
        isRequired: false, 
        isRelaxedText: true, 
        name: t('description'), 
        value: selectedTask, 
        label: t('description'), 
        onEnter: this._onEnterPress}
      )
    ];
    const title = `${tankTypeFormatted} ${t('icons_admin_title')}`;
    const ICONS_MAPPING = getIconsMapping(t);
    return (
      React.createElement(AdminScaffolding, {
        moduleName: "ADMIN_BEER_STYLE_CONFIGURATION", 
        messages: messages, 
        additionalSubmitValue: {styleBeerId: currentBeerStyle, typeTank: typeTank}, 
        additionalButtons: additionalButtons, 
        title: title, 
        contextHolder: contextHolder, 
        value: selectedTask, 
        fetchItems: this.fetchBeerStyleTasks, 
        headerFields: formFieldsEl, 
        onAdd: this._onAddBeerStyle, 
        onAddText: t('label_add'), 
        onChange: this._onChangeBeerStyle, 
        onCancel: this._onCancel, 
        onDelete: this._onDeleteBeerStyle, 
        breadcrumb: this._getBreadcrumbLinks(currentBeerStyleName), 
        addEnterKeyDown: this._addEnterKeyDown
      }, 

        React.createElement(AdminScaffoldingTable, {
          sortByColumn: "day", 
          onRowSelection: this._onRowSelection, 
          value: selectedTask, 
          filteredColumns: ['label', 'description'], 
          columnNames: [isAdminBrewing
            ? t('beer_style_configuration_admin_brew_turn_order')
            : t('day'),
            t('icon'),
            t('label'),
            t('description')
          ], 
          displayAttributes: [
            {
              getHTML: this._getStampsIcons
            },
            'displayIcon',
            'label',
            'description'
          ]}, 
          beerStyleConfigurationTasks && beerStyleConfigurationTasks.length > 0
          ? beerStyleConfigurationTasks.map(task => {
            task.displayIcon = ICONS_MAPPING[task.typeTask];
            return task;
            })
          : beerStyleConfigurationTasks
        )
      ));
  }
});

function existAnotherTaskWithSameDay(items, currentDay, day) {
  if (currentDay) {
    return includes(filter(map(items, config => +config.day), (dayFilter) => dayFilter !== currentDay), +day);
  } else {
    return includes(map(items, config => +config.day), +day);
  }
}


/**
 * Retrieve the days could be select the consumer.
 * @param {Object}
 * @returns {Array}
 */
function getAvailablesDays(context) {
  let days = [];
  let index = 0;

  let maxDaysField = get(ContentUtils.getTankTypeConfiguration(context.typeTank), 'getDays');
  const maxDays = +get(context, maxDaysField);

  while (++index <= maxDays) {
    days.push(index);
  }

  return days;
}

module.exports = BeerStyleConfigurationAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/BeerStyleConfigurationAdmin/BeerStyleConfigurationAdmin.jsx
 **/